import {
  Component,
  OnInit,
  Renderer2,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  OrderAuditPromiseService,
  TraderGroupPromiseLookupService,
  ClientPromiseLookupService,
  UserPromiseLookupService,
  ClientActionPromiseService,
  SystemConfigPromiseService,
  Roles,
  SysFeatures,
} from "shared/cubiq-services";
import {
  moment,
  TradingGroupImpl,
  Long,
  ClientContactImpl,
  Client,
  ModelUpdateImpl,
  ModelUpdateType,
  NotificationMethod,
  UserImpl,
  UserType,
  ClientImpl,
  UpdateClientCommentsRequestImpl,
  ClientContact,
} from "shared/cubiq-model-multi-asset";
import { CoreQuote, CoreOrderAudit } from "shared/cubiq-services";
import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { TranslateService } from "@ngx-translate/core";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { trigger, state, animate, transition, style } from "@angular/animations";

import { BfxDialogCommand } from "../bfx-dialogs/models/bfx-dialog-command.enum";
import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxBlotterOrdersActionService } from "../bfx-blotter-orders/bfx-blotter-orders-action.service";
import {
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
  GoldenLayoutService,
} from "../golden-layout/golden-layout-service";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";
import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";
import { LogoutNotificationService } from "../bfx-auth/logout-notification.service";

enum BfxContactManagerComponentTabs {
  Contacts,
  Comments,
  ClientTraders,
}
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-contact-manager",
  templateUrl: "./html/bfx-contact-manager.html",
  standalone: false,
})
export class BfxContactManagerComponent implements AfterViewInit {
  public client: ClientImpl;

  public clientContacts: Array<ClientContactImpl> = [];

  public originalContacts: Array<ClientContactImpl> = [];

  public selectedTraders: Array<UserImpl> = [];

  public clientTraders: Array<UserImpl> = [];

  public originalClientTrader: UserImpl;

  public ready: boolean = false;

  public selectedContact: ClientContactImpl;

  public selectedClientTrader: UserImpl;

  public parentPopup: GoldenLayoutPopout;

  public activeTab: number = 0;

  public clientComment: string = null;

  public privateComment: string = null;

  public locked: boolean = false;

  public cancelling: boolean = false;

  public contactCallback: any = null;

  public commentCallback: any = null;

  public traderCallback: any = null;

  public closeCallback: any = null;

  public editable: boolean = false;

  public enablePrivateComments: boolean = false;

  public enableClientTraders: boolean = false;

  public emptyMessage = `No Contacts`;

  public scrollHeight: string = null;

  // Fixed by Server Model & DB
  public readonly commentSize = "250";

  // indicates if a save is required, when cancelling
  private dataIsDirty: boolean = false;

  private logoutKilling: boolean;

  constructor(
    public clientService: ClientPromiseLookupService,
    public userService: UserPromiseLookupService,
    public translationService: TranslateService,
    public blotterOrderService: BfxBlotterOrdersActionService,
    public clientActionService: ClientActionPromiseService,
    public layoutService: GoldenLayoutService,
    public systemConfigurationService: SystemConfigPromiseService,
    public element: ElementRef,
    private logoutNotificationService: LogoutNotificationService,
    protected cd: ChangeDetectorRef,
  ) {
    this.emptyMessage = this.translationService.instant(
      "contacts.manager.client.contacts.emptyMessage",
    );

    this.registerClientModelUpdates();
    this.registerUserModelUpdates();

    this.logoutNotificationService.getLogoutNotification().subscribe(
      (v) => {
        this.logoutKilling = true;

        // don't suppress logout!
        v.res(true);
      },
      () => {},
      () => {},
    );
  }

  ngAfterViewInit() {
    this.adjustTableHeight();
  }

  public glInit(data: any, container: any, state: any): void {
    this.client = data.client;

    this.originalContacts = data.selectedContacts.slice(0);

    if (data.selectedTrader != null && data.selectedTrader.value != null) {
      this.userService.getUser(data.selectedTrader.value).then((value: UserImpl) => {
        this.selectedClientTrader = value;
        this.originalClientTrader = value;
      });
    } else {
      this.selectedClientTrader = data.selectedTrader;
      this.originalClientTrader = data.selectedTrader;
    }

    this.contactCallback = data.contactCallback;
    this.commentCallback = data.commentCallback;
    this.traderCallback = data.traderCallback;
    this.closeCallback = data.closeCallback;

    this.clientComment = this.client.defaultClientComment;
    this.privateComment = this.client.defaultPrivateComment;

    this.systemConfigurationService
      .hasRole(Roles.ORDER_ENTRY_CONTACTS_MANAGER_UPDATE)
      .then((value: boolean) => (this.editable = value));
    this.systemConfigurationService
      .getSystemConfig(SysFeatures.featuresEnablePrivateComments)
      .then((value: string) => (this.enablePrivateComments = value == "Y"));
    this.systemConfigurationService
      .getSystemConfig(SysFeatures.clientTraderUsersEnabled)
      .then((value: string) => (this.enableClientTraders = value == "Y"));

    this.reload();
  }

  public reload(clearSelection: boolean = true, activeTab: number = -1): void {
    if (activeTab < 0 || activeTab == 0) {
      let modelSelectedContactIds = [];

      if (Array.isArray(this.clientContacts)) {
        modelSelectedContactIds = this.clientContacts
          .filter((contact: ClientContactImpl) => contact["selected"])
          .map((contact: ClientContactImpl) => contact.id.toString());
      }

      this.clientService
        .getClientContacts(this.client.clientId)
        .then((values: ClientContactImpl[]) => {
          this.clientContacts = values;

          if (this.clientContacts == null) {
            this.clientContacts = [];
          }

          this.clientContacts.map(
            (value: ClientContactImpl, index: number) => (value["index"] = index),
          );
          let originalIds: Array<string> = this.originalContacts.map((value: ClientContactImpl) =>
            value.id.toString(),
          );
          if (clearSelection) {
            this.clientContacts.map(
              (value: ClientContactImpl) =>
                (value["selected"] = originalIds.indexOf(value.id.toString()) >= 0),
            );
          } else {
            this.clientContacts.map(
              (value: ClientContactImpl) =>
                (value["selected"] = modelSelectedContactIds.indexOf(value.id.toString()) >= 0),
            );
          }
          this.ready = true;
        });
    }

    if (activeTab < 0 || activeTab == 2) {
      // as distinct from selection of table
      let modelSelectedClientTrader = null;

      if (Array.isArray(this.clientTraders)) {
        modelSelectedClientTrader = this.clientTraders.find(
          (clientTrader: UserImpl) => clientTrader["selected"],
        );
      }

      this.userService.isPrimed().then(() => {
        this.userService.getAll().then((value: UserImpl[]) => {
          this.clientTraders = value.filter(
            (user: UserImpl) =>
              user.userType == UserType.CLIENT_TRADER && user.clientCode == this.client.clientId,
          );
          this.clientTraders.map((value: UserImpl, index: number) => (value["index"] = index));
          if (clearSelection) {
            this.clientTraders.map(
              (value: UserImpl) =>
                (value["selected"] =
                  this.originalClientTrader != null &&
                  this.originalClientTrader.userCode == value.userCode),
            );
          } else {
            this.clientTraders.map(
              (value: UserImpl) =>
                (value["selected"] =
                  modelSelectedClientTrader != null &&
                  modelSelectedClientTrader.userCode == value.userCode),
            );
          }
        });
      });
    }

    if (activeTab < 0 || activeTab == 1) {
      this.clientService.getActiveClient(this.client.clientId).then((client: ClientImpl) => {
        this.client = client;
        this.clientComment = this.client.defaultClientComment;
        this.privateComment = this.client.defaultPrivateComment;
      });
    }
  }

  adjustTableHeight(): void {
    this.scrollHeight = this.element.nativeElement.offsetHeight - 85 + "px";
    this.cd.detectChanges();
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
    this.parentPopup.setShowRefresh(false);
  }

  /**
   * Indicates if the item actions is enabled: new, edit or delete
   */
  public isItemActionEnabled(): boolean {
    return (
      (this.activeTab == BfxContactManagerComponentTabs.Contacts && this.selectedContact != null) ||
      (this.activeTab == BfxContactManagerComponentTabs.ClientTraders &&
        this.selectedClientTrader != null)
    );
  }

  /**
   * Indicates if the selection has changed any time since the component first loaded
   */
  public isSelectionChanged(): boolean {
    return false;
  }

  public getNotificationLabel(notifyMethod: NotificationMethod): string {
    return NotificationMethod[notifyMethod];
  }

  public clientTraderSelectionChanged(event: any, data: any): void {
    this.clientTraders.map(
      (clientTrader: UserImpl) =>
        (clientTrader["selected"] = event == true && data["userCode"] == clientTrader.userCode),
    );
  }

  public onTabChange(event) {
    if (this.activeTab != event.index && this.isSaveEnabled()) {
      let payload: any = null;

      payload = {
        messages: [this.translationService.instant("confirm.contact.switch")],
        title: "switch.contact.title",
        callback: this.save.bind(this, false, this.activeTab),
        callbackNegative: this.reload.bind(this, true, this.activeTab),
      };

      let body: Element = this.element.nativeElement.ownerDocument.body;
      let bfxDialogData: BfxDialogData = new BfxDialogData(
        BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN,
        null,
        null,
        payload,
        body,
      );
      this.blotterOrderService.launchNewDialog(bfxDialogData);
    }

    this.activeTab = event.index;
  }

  public confirmDeleteContact() {
    this.clientActionService.deleteClientContact(this.selectedContact.id.toString()).then(() => {
      // deleting a contact is persistent
      // we now have to save the contacts back to whoever called us.
      // even if they cancel out of the window
      this.dataIsDirty = true;
      setTimeout(this.reload.bind(this, false), 500);
    });
  }

  public confirmDeleteTrader() {
    this.clientActionService
      .deleteClientTrader(this.client.clientId, this.selectedClientTrader.userName)
      .then(() => {
        this.userService.deleteItem(this.selectedClientTrader).then(() => {
          setTimeout(this.reload.bind(this, false), 500);
        });
      });
  }

  public newItem(event: Event): void {
    let payload: any = null;
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    let title: string = "New Contact";
    let itemType: DashboardItemType = DashboardItemType.ContactEdit;

    this.lock();

    if (this.activeTab == 0) {
      payload = {};
      config.data = {
        client: this.client,
        callback: this.saveContact.bind(this),
        callbackClose: this.unlock.bind(this),
      };
      config.preferredSize = { width: 450, height: 590 };
    } else {
      payload = {};
      config.data = {
        client: this.client,
        callback: this.saveClientTrader.bind(this),
        callbackClose: this.unlock.bind(this),
      };
      config.preferredSize = { width: 400, height: 450 };
      title = "New Client Trader";
      itemType = DashboardItemType.ClientTraderEdit;
    }

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.sourceEvent = event;

    this.layoutService.launchFromDashboard(
      title,
      itemType,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  public editItem(event: Event): void {
    if (!this.editable) return;
    let payload: any = null;
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    let title: string = "Edit Contact";
    let itemType: DashboardItemType = DashboardItemType.ContactEdit;

    this.lock();

    if (this.activeTab == 0) {
      payload = {};
      let selectedContacts: Array<ClientContactImpl> = this.clientContacts.filter(
        (clientContact: ClientContactImpl) => clientContact["selected"],
      );
      config.data = {
        client: this.client,
        clientContact: this.selectedContact,
        callback: this.saveContact.bind(this),
        callbackClose: this.unlock.bind(this),
      };
      config.preferredSize = { width: 450, height: 590 };
    } else {
      payload = {};
      config.data = {
        client: this.client,
        clientTrader: this.selectedClientTrader,
        callback: this.saveClientTrader.bind(this),
        callbackClose: this.unlock.bind(this),
      };
      config.preferredSize = { width: 400, height: 450 };
      title = "Edit Client Trader";
      itemType = DashboardItemType.ClientTraderEdit;
    }

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.sourceEvent = event;

    this.layoutService.launchFromDashboard(
      title,
      itemType,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  public rowStyleClass(data: any): string {
    if (data) return data.selected ? "row-selected" : "";
  }

  public saveContact(contact: ClientContactImpl): void {
    if (contact.notifyEntry == null) {
      contact.notifyEntry = NotificationMethod.NONE;
    }

    if (contact.notifyExpiry == null) {
      contact.notifyExpiry = NotificationMethod.NONE;
    }

    if (contact.notifyFill == null) {
      contact.notifyFill = NotificationMethod.NONE;
    }

    if (contact.isDefaultFg == null) {
      contact.isDefaultFg = false;
    }

    if (contact.notifyModify == null) {
      contact.notifyModify = NotificationMethod.NONE;
    }

    if (contact.notifyCancel == null) {
      contact.notifyCancel = NotificationMethod.NONE;
    }

    this.clientActionService
      .saveClientContact(
        contact.id != null ? contact.id.toString() : null,
        contact.clientCd,
        contact.contactNameTxt,
        contact.deskTxt,
        contact.mobileTxt,
        contact.smsTxt,
        contact.emailTxt,
        contact.isDefaultFg,
        contact.notifyEntry,
        contact.notifyExpiry,
        contact.notifyFill,
        contact.notifyModify,
        contact.notifyCancel,
      )
      .then(() => {
        this.selectedContact = contact;
        setTimeout(this.reload.bind(this, false), 500);
      });
  }

  public saveClientTrader(clientTrader: UserImpl): void {
    this.clientActionService
      .saveClientTrader(
        clientTrader.clientCode,
        clientTrader.comment,
        clientTrader.userName,
        clientTrader.userCode,
        clientTrader.desk,
        clientTrader.smsNumber,
        clientTrader.emailAddress,
        clientTrader.isDefault,
      )
      .then(() => {
        if (clientTrader["selected"]) {
          this.commentCallback(
            this.client.defaultPrivateComment,
            this.client.defaultClientComment,
            clientTrader,
          );
        }

        setTimeout(this.reload.bind(this, false), 500);
      });
  }

  public deleteItem(): void {
    let payload: any = null;

    if (this.activeTab == BfxContactManagerComponentTabs.Contacts) {
      payload = {
        messages: [this.translationService.instant("confirm.contact.delete")],
        title: "delete.contact.title",
        showConfirmationMessage: false,
        callback: this.confirmDeleteContact.bind(this),
        callbackNegative: this.unlock.bind(this),
      };
    } else {
      payload = {
        messages: [this.translationService.instant("confirm.trader.delete")],
        title: "delete.trader.title",
        showConfirmationMessage: false,
        callback: this.confirmDeleteTrader.bind(this),
        callbackNegative: this.unlock.bind(this),
      };
    }

    let body: Element = this.element.nativeElement.ownerDocument.body;
    let bfxDialogData: BfxDialogData = new BfxDialogData(
      BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN,
      null,
      null,
      payload,
      body,
    );
    this.blotterOrderService.launchNewDialog(bfxDialogData);
  }

  public isSaveEnabled(): boolean {
    let saveEnabled: boolean = false;

    if (this.activeTab == BfxContactManagerComponentTabs.Contacts) {
      let originalIds: Array<string> = this.originalContacts.map((value: ClientContactImpl) =>
        value.id.toString(),
      );
      let newIds: Array<string> = this.clientContacts
        .filter((value: ClientContactImpl) => value["selected"])
        .map((value: ClientContactImpl) => value.id.toString());

      saveEnabled =
        originalIds.length != newIds.length ||
        originalIds.some((id: string) => newIds.indexOf(id) < 0);
    } else if (this.activeTab == BfxContactManagerComponentTabs.Comments) {
      saveEnabled =
        this.clientComment != this.client.defaultClientComment ||
        this.privateComment != this.client.defaultPrivateComment;
    } else {
      let selected: UserImpl[] = this.clientTraders.filter(
        (clientTrader: UserImpl) => clientTrader["selected"],
      );
      if (selected.length == 1) {
        saveEnabled =
          (this.originalClientTrader == null && selected[0] != null) ||
          (this.originalClientTrader != null && selected[0] == null) ||
          (this.originalClientTrader != null &&
            this.originalClientTrader.userCode != selected[0].userCode);
      } else {
        saveEnabled = this.originalClientTrader != null;
      }
    }

    return saveEnabled;
  }

  public save(closeOnSave: boolean = true, activeTab: number = -1): void {
    this.lock();

    let active: number = activeTab >= 0 ? activeTab : this.activeTab;

    switch (active) {
      case BfxContactManagerComponentTabs.Contacts:
        this.saveClientContact(closeOnSave);
        break;
      case BfxContactManagerComponentTabs.Comments:
        this.saveComment(closeOnSave);
        break;
      case BfxContactManagerComponentTabs.ClientTraders:
        this.saveTrader(closeOnSave);
        break;
    }
  }

  protected saveClientContact(closeOnSave: boolean): void {
    let selectedContacts: Array<ClientContactImpl> = this.clientContacts.filter(
      (value: ClientContactImpl) => value["selected"],
    );
    this.contactCallback(selectedContacts);
    this.originalContacts = selectedContacts;
    if (closeOnSave) {
      this.closeWindow();
    } else {
      this.unlock();
    }
  }

  protected saveComment(closeOnSave: boolean): void {
    this.clientActionService
      .updateClientComments(this.client.clientId, this.clientComment, this.privateComment)
      .then(() => {
        let selected: UserImpl[] = this.clientTraders.filter(
          (clientTrader: UserImpl) => clientTrader["selected"],
        );
        let clientTrader = null;

        if (selected.length == 1) {
          clientTrader = selected[0];
        }

        this.client.defaultPrivateComment = this.privateComment;
        this.client.defaultClientComment = this.clientComment;

        this.commentCallback(this.privateComment, this.clientComment, clientTrader);

        if (closeOnSave) {
          this.closeWindow();
        } else {
          this.unlock();
        }
      });
  }

  protected saveTrader(closeOnSave: boolean): void {
    let selected: UserImpl[] = this.clientTraders.filter(
      (clientTrader: UserImpl) => clientTrader["selected"],
    );

    let clientTrader: UserImpl = null;
    if (selected.length == 1) {
      clientTrader = selected[0];

      if (
        this.originalClientTrader &&
        clientTrader &&
        this.originalClientTrader.userCode !== clientTrader.userCode
      ) {
        this.commentCallback(
          this.client.defaultPrivateComment,
          this.client.defaultClientComment,
          clientTrader,
        );
      }
    }

    this.traderCallback(clientTrader);
    this.originalClientTrader = clientTrader;

    if (closeOnSave) {
      this.closeWindow();
    } else {
      this.unlock();
    }
  }

  public cancelContactManager(): void {
    this.reload();
  }

  public onClose(): boolean {
    if (this.logoutKilling) {
      if (this.closeCallback != null) {
        this.closeCallback();
      }

      return true;
    }

    if (this.parentPopup.disableAllActions) {
      return false;
    }

    if (this.isSaveEnabled() && !this.cancelling) {
      let payload: any = null;

      payload = {
        messages: [this.translationService.instant("warn.unsaved.contact.close")],
        title: "switch.contact.title",
        callback: () => {},
        callbackNegative: () => {},
      };

      let bfxDialogData: BfxDialogData = new BfxDialogData(
        BfxDialogCommand.DIALOG_GENERIC_OK,
        null,
        null,
        payload,
      );
      this.blotterOrderService.launchNewDialog(bfxDialogData);

      return false;
    } else {
      if (this.closeCallback != null) {
        this.closeCallback();
      }

      this.cancelling = false;
    }
  }

  public cancel(): void {
    if (this.dataIsDirty) {
      // if we had deleted contacts - we need to save
      // so the caller does not end up having a deleted contact selected.
      return this.save();
    }

    this.cancelling = true;
    this.closeWindow();
  }

  public closeWindow(): void {
    if (this.closeCallback != null) {
      this.closeCallback();
    }
    this.unlock();
    this.parentPopup.close();
  }

  public lock(): void {
    this.locked = this.parentPopup.disableAllActions = true;
  }

  public unlock(): void {
    this.locked = this.parentPopup.disableAllActions = false;
  }

  public registerClientModelUpdates(): void {
    this.clientService.getModelUpdateSubject().subscribe((update: ModelUpdateImpl) => {
      if (update instanceof ModelUpdateImpl) {
        if (update.payLoad instanceof ClientImpl) {
          return;
        } else if (!(update.payLoad instanceof ClientContactImpl)) {
          return;
        }

        let clientContact: ClientContactImpl = update.payLoad as ClientContactImpl;
        if (clientContact.clientCd != this.client.clientId) {
          return;
        }

        switch (update.eventType) {
          case ModelUpdateType.CREATE:
            // ignore both this.originalContacts and modelSelectedContactIds
            clientContact["index"] = this.clientContacts.length;
            clientContact["selected"] = false;

            let cc = [];
            if (Array.isArray(this.clientContacts)) cc = this.clientContacts.slice(0);
            cc.push(clientContact);
            this.clientContacts = cc;
            break;
          case ModelUpdateType.UPDATE:
            if (Array.isArray(this.clientContacts)) {
              this.clientContacts = this.clientContacts.map(
                (existingClientContact: ClientContactImpl) => {
                  if (
                    Long.fromValue(clientContact.id).equals(
                      Long.fromValue(existingClientContact.id),
                    )
                  ) {
                    clientContact["index"] = existingClientContact["index"];
                    clientContact["selected"] = existingClientContact["selected"];
                    return clientContact;
                  }
                  return existingClientContact;
                },
              );

              if (this.selectedContact instanceof ClientContactImpl) {
                if (
                  Long.fromValue(clientContact.id).equals(Long.fromValue(this.selectedContact.id))
                ) {
                  this.selectedContact = this.clientContacts[this.selectedContact["index"]];
                }
              }
            }
            break;
          case ModelUpdateType.DELETE:
            if (Array.isArray(this.clientContacts)) {
              this.clientContacts = this.clientContacts.filter(
                (existingClientContacts: ClientContactImpl) => {
                  if (
                    Long.fromValue(clientContact.id).equals(
                      Long.fromValue(existingClientContacts.id),
                    )
                  ) {
                    return false;
                  }
                  return true;
                },
              );
            }

            break;
          default:
            break;
        }
      }
    });
  }

  public registerUserModelUpdates(): void {
    this.userService.getModelUpdateSubject().subscribe((update: ModelUpdateImpl) => {
      if (update instanceof ModelUpdateImpl) {
        let user: UserImpl = update.payLoad as UserImpl;
        if (user.userType != UserType.CLIENT_TRADER || user.clientCode != this.client.clientId) {
          return;
        }

        switch (update.eventType) {
          case ModelUpdateType.CREATE:
            user["index"] = this.clientTraders.length;
            user["selected"] = false;

            let ct = [];
            if (Array.isArray(this.clientTraders)) ct = this.clientTraders.slice(0);
            ct.push(user);
            this.clientTraders = ct;
            break;
          case ModelUpdateType.UPDATE:
            if (Array.isArray(this.clientTraders)) {
              this.clientTraders = this.clientTraders.map<UserImpl>((existingUser: UserImpl) => {
                if (Long.fromValue(user.userId).equals(Long.fromValue(existingUser.userId))) {
                  // updated
                  user["index"] = existingUser["index"];
                  user["selected"] = existingUser["selected"];
                  return user;
                }

                return existingUser;
              });

              if (this.selectedClientTrader instanceof UserImpl) {
                if (
                  Long.fromValue(user.userCode).equals(
                    Long.fromValue(this.selectedClientTrader.userCode),
                  )
                ) {
                  this.selectedClientTrader =
                    this.clientTraders[this.selectedClientTrader["index"]];
                }
              }
            }
            break;
          case ModelUpdateType.DELETE:
            if (Array.isArray(this.clientTraders)) {
              this.clientTraders = this.clientTraders.filter((existingUser: UserImpl) => {
                if (Long.fromValue(user.userId).equals(Long.fromValue(existingUser.userId))) {
                  // updated
                  return false;
                }

                return true;
              });
            }
            break;
          default:
            break;
        }
      }
    });
  }
}
